import { gql } from '@apollo/client';

export const FIND_PATIENT_BY_MOBILE = gql`
  query FindPatient($input: FindPatientInput!) {
    findPatient(input: $input) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      EmailId
      Address
      Relationship
      IsFamilyHead
      FamilyHeadId
    }
  }
`;

export const FIND_FAMILY_MEMBERS = gql`
  query FindFamilyMembers($mobile: String!) {
    findFamilyMembers(mobile: $mobile) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      EmailId
      Relationship
      IsFamilyHead
      FamilyHeadId
    }
  }
`;

export const CHECK_PATIENT_AND_FAMILY = gql`
  query CheckPatientAndFamily($mobile: String!) {
    findPatient(input: { mobile: $mobile }) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      EmailId
      Relationship
      IsFamilyHead
      FamilyHeadId
    }
    
    findFamilyMembers(mobile: $mobile) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      EmailId
      Relationship
      IsFamilyHead
      FamilyHeadId
    }
  }
`;

export const CREATE_PATIENT = gql`
  mutation CreatePatient($input: CreatePatientInput!) {
    createPatient(input: $input) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      EmailId
      Relationship
      IsFamilyHead
      FamilyHeadId
    }
  }
`;

export const SEARCH_PATIENTS = gql`
  query SearchPatients($searchTerm: String!) {
    searchPatients(searchTerm: $searchTerm) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
    }
  }
`;

export const GET_RECENT_PATIENTS = gql`
  query GetRecentPatients($limit: Int) {
    getRecentPatients(limit: $limit) {
      CustomerId
      CustomerName
      MobileNumber
      Age
      Gender
      CreatedOn
    }
  }
`;
